import { Flex, Form, FormProps, Input, Modal, Spin } from "antd";
import { addOrUpdateDocumentType } from "api/services/DocumentTypeService";
import { TDocumentType } from "api/services/models/types";
import { useTDAuthentication } from "auth/AuthenticationProvider";
import { AxiosError } from "axios";
import { Header } from "components/common/Header";
import ErrorViewer from "components/ErrorViewer";
import { useState } from "react";

type TAddOrUpdateDocumentTypeProps = {
  documentType?: TDocumentType;
  onClose: (documentType?: TDocumentType) => void;
};
const AddOrUpdateDocumentType = ({ documentType, onClose }: TAddOrUpdateDocumentTypeProps) => {
  const { accountId } = useTDAuthentication();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<AxiosError | null>();

  const onSave = () => {
    form
      .validateFields()
      .then(() => form.submit())
      .catch(e => console.log(e));
  };
  const onFinish: FormProps<TDocumentType>["onFinish"] = values => {
    setLoading(true);
    setError(null);
    addOrUpdateDocumentType(accountId!, { ...documentType, ...values }, documentType == null)
      .then(onClose)
      .catch(setError)
      .finally(() => setLoading(false));
  };

  return (
    <Modal
      maskClosable={false}
      title={
        <Header
          header="New Document Type"
          editHeader="Edit Document Type"
          isEditing={documentType != null}
          onSubmit={onSave}
          onClose={onClose}
        />
      }
      open={true}
      footer={null}
      closeIcon={null}
      centered={true}
      onCancel={() => onClose()}>
      {loading && (
        <Flex justify="space-around" style={{ width: "100%", textAlign: "center" }}>
          <Spin tip="Saving, please wait..." />
        </Flex>
      )}
      {error && <ErrorViewer error={error} />}
      {!loading && (
        <Form
          form={form}
          labelAlign="right"
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 14 }}
          name="add_or_update_document_type"
          initialValues={documentType}
          onFinish={onFinish}
          validateTrigger={["onChange", "onBlur"]}
          clearOnDestroy={true}>
          <Form.Item
            label={
              <label htmlFor="documentTypeId" className="input-label">
                Document Type Id
              </label>
            }
            name="documentTypeId"
            rules={[{ required: true, max: 25, message: "Please enter Document Type ID" }]}>
            <Input readOnly={documentType != null} className="filter-input-transparent" />
          </Form.Item>
          <Form.Item
            label={
              <label htmlFor="name" className="input-label">
                Name
              </label>
            }
            name="documentTypeName"
            rules={[{ required: true, message: "Please enter Document Type Name" }]}>
            <Input className="filter-input-transparent" />
          </Form.Item>
          <Form.Item
            label={
              <label htmlFor="description" className="input-label">
                Description
              </label>
            }
            name="description"
            rules={[{ max: 25 }]}>
            <Input className="filter-input-transparent" />
          </Form.Item>
          <Form.Item
            label={
              <label htmlFor="phoneId" className="input-label">
                Phone Id
              </label>
            }
            name="phoneId"
            rules={[{ max: 4 }]}>
            <Input className="filter-input-transparent" />
          </Form.Item>
          <Form.Item
            label={
              <label htmlFor="clientPhoneId" className="input-label">
                Client Phone Id
              </label>
            }
            name="clientPhoneId"
            rules={[{ required: true, max: 25, message: "Please enter Client Phone ID" }]}>
            <Input className="filter-input-transparent" />
          </Form.Item>
          <Form.Item
            label={
              <label htmlFor="clientDocumentTypeId" className="input-label">
                Client Document Type Id
              </label>
            }
            name="clientDocumentTypeId"
            rules={[{ max: 25 }]}>
            <Input className="filter-input-transparent" />
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};

export default AddOrUpdateDocumentType;
